import { render, staticRenderFns } from "./PageGroup.vue?vue&type=template&id=ac1d8690&scoped=true&"
import script from "./PageGroup.vue?vue&type=script&lang=js&"
export * from "./PageGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1d8690",
  null
  
)

/* custom blocks */
import block0 from "./PageGroup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
